import { type CoachComment } from '@/lib/types';
import { createContext } from 'react';

const CoachCommentsContext = createContext<{
  coachComments: CoachComment[];
  addCoachCommentApiUrl: string;
  isInLogEntry: boolean;
}>({
  coachComments: [],
  addCoachCommentApiUrl: '',
  isInLogEntry: false,
});

export default CoachCommentsContext;
